import { TileRoleRoute } from '@/types'
import { faDumpster } from '@fortawesome/free-solid-svg-icons'
import { Roles } from '@/auth/azure/Roles'
import { ManagementGridFactory } from '@/routes/admin/components/ManagementGrid/ManagementGridFactory'
import { DumpsPageRoute } from '@/routes/dumps/DumpsPage.route'

export const DumpRoute: TileRoleRoute = {
  path: 'dump',
  text: 'Dump',
  faIcon: faDumpster,
  element: (
    <ManagementGridFactory
      entity="stato_dump"
      referencesCollection="dumps"
      referencesTitle="Dump"
      displayField="ded_Dis"
      entityRoute={DumpsPageRoute.path as string}
    />
  ),
  handle: {
    crumb: () => ({
      label: 'Dump',
      icon: faDumpster,
    }),
  },
  mainMenuRoute: false,
  tile: true,
  allowedRoles: [Roles.GlobalAdministrator],
}
